import type { ExtraRatesResponse } from '../../model/extra-rates/interfaces'

import { useCommonStore } from '@shared/model'
import { useAdminRoutes } from '@shared/lib/routes'

import { useExtraRatesStore } from '../../model/extra-rates/store'

interface ExtraRatesApiOptions {
  onStart?: () => void
  onSuccess?: (data: ExtraRatesResponse) => void
  onError?: (err: unknown) => void
  onFinish?: () => void
}

export const useExtraRatesApi = async (options?: ExtraRatesApiOptions): Promise<ExtraRatesResponse | null> => {
  const { $axios } = useNuxtApp()

  const url = useAdminRoutes('admin.demo-slots.extra-rates')

  const extraRatesStore = useExtraRatesStore()
  const commonStore = useCommonStore()

  options?.onStart?.()
  commonStore.setLoading(true)

  try {
    const { data } = await $axios.get(url!)
    const response: ExtraRatesResponse = data.data

    extraRatesStore.setDaysOfWeek(response.schema.days_of_week)
    commonStore.setLoading(false)

    options?.onSuccess?.(response)

    return response
  } catch (err: unknown) {
    console.error(err)
    commonStore.setLoading(false)
    options?.onError?.(err)

    return null
  } finally {
    options?.onFinish?.()
  }
}
